// extracted by mini-css-extract-plugin
export default {"card":"Files_card__6QEjx","btn":"Files_btn__WsbIT","btnIcon":"Files_btnIcon__VBzBL","cell":"Files_cell__wYDGs"};